// FloatingCamera.jsx - Larger clean draggable camera
import React, { useEffect, useRef, useState } from "react";
 
const FloatingCamera = () => {
  const videoRef = useRef(null);
  const [position, setPosition] = useState({ x: 20, y: 20 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  // Set initial position to bottom-left after component mounts
  useEffect(() => {
    const bottomY = window.innerHeight - 300 - 20;  // 300 is height, 20 is margin from bottom
    setPosition({ x: 20, y: Math.max(0, bottomY) });  // Ensure it doesn't go negative
  }, []);
 
  useEffect(() => {
    let activeStream = null;
    let isMounted = true;

    navigator.mediaDevices
      .getUserMedia({
        video: { width: 1280, height: 720, facingMode: "user" },
        audio: false,
      })
      .then((stream) => {
        if (isMounted) {
          activeStream = stream;
          if (videoRef.current) videoRef.current.srcObject = stream;
        } else {
          // Component unmounted before stream was ready, stop it immediately
          stream.getTracks().forEach((t) => t.stop());
        }
      })
      .catch((err) => console.error("Camera error:", err));

    return () => {
      isMounted = false;
      try {
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.srcObject = null;
        }
      } catch (e) {}

      try {
        if (activeStream) {
          activeStream.getTracks().forEach((t) => {
            try {
              t.stop();
            } catch (e) {}
          });
          activeStream = null;
        }
      } catch (e) {
        console.warn("FloatingCamera cleanup error:", e);
      }
    };
  }, []);
 
  const handleMouseDown = (e) => {
    setDragging(true);
    setOffset({ x: e.clientX - position.x, y: e.clientY - position.y });
  };
 
  const handleMouseMove = (e) => {
    if (dragging) {
      setPosition({
        x: Math.max(0, Math.min(window.innerWidth - 400, e.clientX - offset.x)),
        y: Math.max(0, Math.min(window.innerHeight - 300, e.clientY - offset.y)),
      });
    }
  };
 
  const handleMouseUp = () => setDragging(false);
 
  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  });
 
  return (
    <div
      onMouseDown={handleMouseDown}
      className="fixed z-50 border border-[#E6E0F3] bg-white rounded-xl shadow-lg overflow-hidden cursor-move select-none transition-all duration-300"
      style={{
        width: 420, // 📏 Bigger width
        height: 300, // 📏 Bigger height
        top: position.y,
        left: position.x,
      }}
    >
      {/* Header */}
      <div className="bg-gradient-to-r from-[#4B1498] to-[#6A2BE0] text-white px-3 py-2 text-sm font-semibold rounded-t-xl">
        Live Camera
      </div>
 
      {/* Video feed */}
      <div className="w-full h-full bg-gradient-to-br from-[#EBDDFD] via-[#F7F1FF] to-[#E4D3FB]">
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className="w-full h-full object-cover rounded-b-xl"
        />
      </div>
    </div>
  );
};
 
export default FloatingCamera;
